import moment from 'moment';
import 'moment/locale/ja';
import { useEffect, useRef, useState } from "react";
import { connect, useStore } from "react-redux";
import { useHistory } from "react-router";
import useMedia from "use-media";
import { default as commonUtil, default as CommonUtil } from '../../../common/commonUtil';
import { deleteFavoriteCondition, getAreaList, getCityListByCountry, getCountryListByArea, setFavoriteCondition, setTempReserveInfo } from "../../../const/RTCC";
import Const from '../../../const/RTCC/Const';
import constant from "../../../const/RTCC/Const";
import MessageConst from "../../../const/RTCC/messageConst";
import icon_car from '../../../resources/RTCC/icon_car.PNG';
import icon_pin from '../../../resources/RTCC/icon_pin.PNG';
import common from "../../../resources/RTCC/js/common/common";
import { Button } from "../../atoms/RTCC/button";
import { Image } from "../../atoms/RTCC/image";
import { Label } from "../../atoms/RTCC/label";
import { ModalClose } from "../../atoms/RTCC/modalClose";
import './../../../resources/RTCC/css/popup/popup.css';
import messageConst from '../../../const/RTCC/messageConst';

const ReservationPopupContainer = (props) => {
    const {
        login,
        course,
        detailCondition,
        favoriteCondition,
        reserveInfo,
        startTime,
        toUserInputInfo,
        setRoomHome,
        setRoomOverseas,
        setKeyWord,
        setHuman,
        setCourse,
        setDetailCondition,
        setReserveInfo,
        setToUserInputInfo,
        reserveCancelInfo,
        setReserveCancelInfo,
        state,
        setPopupMode,
        setPopupMessage,
        onClickClosePopupWindow,
        setSelectRecommendFlg,
        setDisplaySwitchTab,
        stayInfo,
        onClickCountWindow,
        createAgeCountList } = props;
    const store = useStore();
    const useMediaFlag = useMedia({ maxWidth: '820px' });
    const [isMobilePhone, setIsMobilePhone] = useState(false);
    const [display, setDisplay] = useState(false);
    const [courseName, setCourseName] = useState([]);
    const [teeTime, setTeeTime] = useState([]);
    const [detailName, setDetailName] = useState([]);
    const [apiData, setApiData] = useState();
    const popupTitle = state.popupTitle;
    const popupMode = state.popupMode;
    const popupMessage = state.popupMessage;
    const contentsType = state.contentsType ? state.contentsType : "";
    let dataList = [];
    let popupData = state.popupData;
    let popupDataList = state.popupDataList;
    let footerClass = "";
    const startTimes = constant.START_TIMES;
    const popupRef = useRef(null);
    moment.locale('ja')

    if (popupMode == 'savedSearch') {
        footerClass = "decision";
        dataList = popupDataList;
    } else if (popupMode == 'message') {
        footerClass = "message"
    } else if (popupMode == 'bookConfirm') {
        footerClass = "reservation";
        dataList = popupDataList;
    } else if (popupMode == 'hotelDtail') {
        footerClass = "hotel";
        dataList = [
            {
                label: popupData.hotelName,
                text: popupData.propertyDescriptions,
                type: "title"
            },
            {
                label: "所在地",
                address: popupData.address,
                access: popupData.access,
                type: "location"
            },
            {
                label: "設備",
                text: popupData.propertyAmenities,
                type: "info"
            },
            {
                label: "その他",
                text: popupData.remark,
                type: "info"
            }

        ]
    } else if (popupMode == 'planDetail') {
        if (popupData.recommendFlg) {
            footerClass = "recommend"
        } else {
            footerClass = "hotel";
        }
        dataList = [
            {
                label: popupData.hotelName,
                text: "",
                type: "title"
            },
            {
                label: "プラン名",
                text: popupData.planName,
                type: "info"
            },
            {
                label: "プラン内容",
                text: popupData.planDescriptions,
                type: "info"
            },
            {
                label: "客室",
                text: popupData.roomName,
                type: "info"
            },
            {
                label: "客室説明",
                text: popupData.roomDescriptions,
                type: "info"
            },
            {
                label: "旅行代金",
                text: popupData.fee,
                type: "info"
            },
            {
                label: "注意事項",
                text: popupData.notes,
                type: "info"
            },
            {
                label: "お知らせ",
                text: popupData.notification,
                type: "info"
            },
            {
                label: "取消料",
                text: popupData.cancelDescriptions ? CommonUtil.replaceSpecialChar(popupData.cancelDescriptions) : "",
                type: "cancelDescriptions"
            },

        ]
    } else if (popupMode == "saveFavorite") {
        footerClass = "saveFavorite";
    }
    const history = useHistory();

    useEffect(() => {
        if (useMediaFlag) {
            setIsMobilePhone(true);
        } else {
            setIsMobilePhone(false);
        }
    }, [useMediaFlag]);
    useEffect(() => {
        popupRef.current.scrollTop = 0;
        if (document.getElementById("popupText")) {
            let element = document.getElementById("popupText");
            if (contentsType == "conditions") {
                element.style.textAlign = "left";
                element.style.margin = "30px 20px"
            }
            element.innerHTML = commonUtil.replaceSpecialChar(popupMessage);
        }
    });

    // 決定
    const onClickDecide = () => {
        // エリア設定処理
        common.doPost(getAreaList, {}, afterGetArea);
        onClickCountWindow();
    }
    const afterGetArea = (res) => {
        let resData = state.resData;
        const data = res.data;
        if (data.resultCode != 0) {
            console.log(data.errorMessage);
            return;
        }
        if (res.data.areaList) {
            let areas = CommonUtil.getRadioList(res.data.areaList, "areaId", "areaName", false);
            let roomHome = store.getState().roomHome;
            let roomOverseas = store.getState().roomOverseas;
            let stayInfo = [];
            let dispArea = "";
            let areaId = "";
            let dispRoom = "";
            for (let i in areas) {
                let index = resData.destinationArea.areaId.indexOf(areas[i].value);
                if (index >= 0) {
                    areas[i].checked = true;
                    dispArea = dispArea + (dispArea == "" ? "" : ", ");
                    dispArea = dispArea + areas[i].text;
                    areaId = areaId + (areaId == "" ? "" : ",");
                    areaId = areaId + areas[i].value;
                } else {
                    areas[i].checked = false;
                }
            }
            let areaList = [];
            if (areaId != "1") {
                if (setDisplaySwitchTab) {
                    setDisplaySwitchTab(true);
                }
                areaList = areas.filter(value => {
                    return value.value != "1"
                });
            } else {
                if (setDisplaySwitchTab) {
                    setDisplaySwitchTab(false);
                }
                areaList = areas.filter(value => {
                    return value.value == "1"
                });
            }
            if (areaId != "1") {
                roomHome.forEach((data) => {
                    if (data.id == resData.roomCount) {
                        data.selected = true;
                        dispRoom = data.id;
                    } else {
                        data.selected = false;
                    }
                })
            } else {
                roomOverseas.forEach((data) => {
                    if (data.id == resData.roomCount) {
                        data.selected = true;
                        dispRoom = data.id;
                    } else {
                        data.selected = false;
                    }
                })

            }


            for (let i = 0; i < dispRoom; i++) {
                stayInfo.push({
                    adultNum: 1,
                    childNum: "0",
                    ageList: []
                })
            }

            store.dispatch({ type: "KEYWORD", payload: { keyWord: resData.keyWord ? resData.keyWord : "" } });
            store.dispatch({ type: "AREA", payload: { area: areaList } });
            store.dispatch({ type: "DISP_AREA", payload: { dispArea: dispArea } });
            store.dispatch({ type: "ROOM_HOME", payload: { roomHome: roomHome } });
            store.dispatch({ type: "ROOM_OVERSEAS", payload: { roomOverseas: roomOverseas } });
            store.dispatch({ type: "DISP_ROOM", payload: { dispRoom: dispRoom } });
            store.dispatch({ type: "STAY_INFO", payload: { stayInfo: stayInfo } });
            if (createAgeCountList) {
                createAgeCountList(Const.MAX_CAPACITY);
            }
            common.doPost(getCountryListByArea, { areaId: areaId }, afterGetCountryList)
        }
        onClickCountWindow();
    }
    // 選択する
    const onClickSelect = () => {
        // エリア設定処理
        common.doPost(getAreaList, {}, afterGetAreaList);
        let areaList = store.getState().area;
        setSelectRecommendFlg(true);
    }
    const afterGetAreaList = (res) => {
        let data = res.data;
        if (data.resultCode == 0) {
            let areas = [];
            if (popupData.areaId == "7") {
                setDisplaySwitchTab(true);
                areas = res.data.areaList.filter(value => {
                    return value.areaId == "7"
                });
            } else {
                setDisplaySwitchTab(false);
                areas = res.data.areaList.filter(value => {
                    return value.areaId != "7"
                });
            }
            // リスト作成
            let areaList = CommonUtil.getRadioList(areas, "areaId", "areaName", false);
            let dispArea = "";
            let areaId = "";
            for (let i in areaList) {
                let index = popupData.areaId.indexOf(areaList[i].value);
                if (index >= 0) {
                    areaList[i].checked = true;
                    dispArea = dispArea + (dispArea == "" ? "" : ", ");
                    dispArea = dispArea + areaList[i].text;
                    areaId = areaId + (areaId == "" ? "" : ",");
                    areaId = areaId + areaList[i].value;
                } else {
                    areaList[i].checked = false;
                }
            }

            store.dispatch({ type: "KEYWORD", payload: { keyWord: popupData.hotelName } });
            store.dispatch({ type: "AREA", payload: { area: areaList } });
            store.dispatch({ type: "DISP_AREA", payload: { dispArea: dispArea } });
            common.doPost(getCountryListByArea, { areaId: areaId }, afterGetCountryList)
        }
    }
    const afterGetCountryList = (res) => {
        let data = res.data;
        if (data.resultCode == 0) {
            let dispCountry = "";
            // リスト作成
            if (data.countryList) {
                let countryList = CommonUtil.getCheckList(data.countryList, "countryId", "countryName", false);
                let resData = state.resData;
                let countryId = "";
                for (let i in countryList) {
                    let index = null;
                    if (popupData.recommendFlg) {
                        index = popupData.countryId.indexOf(countryList[i].value);
                    } else {
                        index = resData.destinationArea.countryId ? resData.destinationArea.countryId.indexOf(countryList[i].value) : -1;
                    }
                    if (index >= 0) {
                        countryList[i].checked = true;
                        dispCountry = dispCountry + (dispCountry == "" ? "" : ", ");
                        dispCountry = dispCountry + countryList[i].label;
                        countryId = countryId + (countryId == "" ? "" : ",");
                        countryId = countryId + countryList[i].value;
                    } else {
                        countryList[i].checked = false;
                    }
                }
                store.dispatch({ type: "COUNTRY", payload: { country: countryList } })
                store.dispatch({ type: "DISP_COUNTRY", payload: { dispCountry: dispCountry } });
                common.doPost(getCityListByCountry, { countryId: countryId.split(",") }, afterGetCityList)
            }
        }
    }
    const afterGetCityList = (res) => {
        let data = res.data;
        if (data.resultCode == 0) {
            let dispCity = "";
            // リスト作成
            if (data.cityList) {
                let cityList = CommonUtil.getCheckList(data.cityList, "cityId", "cityName", false);
                let resData = state.resData;
                for (let i in cityList) {
                    let index = null;
                    if (popupData.recommendFlg) {
                        index = popupData.cityId.indexOf(cityList[i].value);
                    } else {
                        index = resData.destinationArea.cityId ? resData.destinationArea.cityId.indexOf(cityList[i].value) : -1;
                    }
                    if (index >= 0) {
                        cityList[i].checked = true;
                        dispCity = dispCity + (dispCity == "" ? "" : ", ");
                        dispCity = dispCity + cityList[i].label;
                    } else {
                        cityList[i].checked = false;
                    }
                }
                store.dispatch({ type: "CITY", payload: { city: cityList } })
                store.dispatch({ type: "DISP_CITY", payload: { dispCity: dispCity } });
            }
        }
        onClickClosePopupWindow();
        window.scroll({ top: 0, behavior: 'smooth' });
    }

    // はい
    const onClickYes = () => {
        common.doPost(setFavoriteCondition, popupData, afterSetFavoriteCondition);
    }
    const afterSetFavoriteCondition = (res) => {
        let data = res.data;
        if (data.resultCode != 0) {
            setPopupMessage(data.errorMessage);
        } else {
            setPopupMessage(MessageConst.SUCCESS_REGIST);
        }
        setPopupMode("message");
    }

    // 削除
    const onClickDelete = (data) => {
        if (popupMode == 'savedSearch') {
            common.doPost(deleteFavoriteCondition, { loginId: login.memberCode }, afterDelete);
        } else if (popupMode == 'reservation') {
            // common.doPost(delReservation, {loginId: loginId}, afterDelete);
        } else if (popupMode == 'bookConfirm') {
            setReserveCancelInfo({
                checkInDate: data.checkInDate,
                checkOutDate: data.checkOutDate,
                hotelId: data.hotelId,
                hotelName: data.hotelName,
                roomId: data.roomId,
                roomName: data.roomName,
                fee: data.fee,
                cancelContents: data.cancelContents,
                paymentId: data.paymentId,
                reserveId: data.reserveId,
                roomList: data.roomList
            });
            history.push("bookingCancelDetail")
        }
    }

    // 予約確認
    const onClickConfirm = (data) => {
        setReserveInfo(data);
        setToUserInputInfo({ ...toUserInputInfo, searchReserveId: null });
        onClickClosePopupWindow();
        history.push("bookingConfirmDetail")
    }

    const afterDelete = (res) => {
        let data = res.data;
        if (data.resultCode != 0) {
            setPopupMessage(data.errorMessage);
        } else {
            setPopupMessage(MessageConst.SUCCESS_DELETE);
        }
        setPopupMode("message");
    }

    // 予約する
    const onClickReserve = () => {
        setToUserInputInfo({
            hotelId: popupData.hotelId,
            hotelName: popupData.hotelName,
            planId: popupData.planId,
            planName: popupData.planName,
            planFee: popupData.fee.slice(1),
            roomNum: popupData.roomNum,
            roomType: popupData.roomName,
            startDate: popupData.startDate,
            endDate: popupData.endDate,
            cancelDescriptions: popupData.cancelDescriptions,
            reserveId: ""
        });

        let reqStayInfo = [];
        stayInfo.map((value, humanIndex) => {
            let ageList = value.ageList;
            let childAge = "";
            ageList.map((value, index) => {
                childAge = index == 0 ? value : childAge + "," + value;
            })
            reqStayInfo.push({
                roomCount: humanIndex + 1,
                adultNum: Number(value.adultNum),
                childNum: Number(value.childNum),
                childAge: childAge
            })
        })
        // 一時予約
        let param = {
            loginId: login.memberCode,
            planId: popupData.planId,
            hotelId: popupData.hotelId,
            checkInDate: moment(popupData.startDate.slice(0, -3), "YYYY年MM月DD日").format('YYYY-MM-DD'),
            checkOutDate: moment(popupData.endDate.slice(0, -3), "YYYY年MM月DD日").format('YYYY-MM-DD'),
            requestVacancyNum: popupData.roomNum,
            stayInfo: reqStayInfo,
        };
        common.doPost(setTempReserveInfo, param, afterSetTempReserveInfo);
    }
    const afterSetTempReserveInfo = (res) => {
        if (res.data.resultCode == 0) {
            history.push("/reserve/rtcc/userInput");
        }

    }

    const popupBody = dataList ? dataList.map((value, index) => {
        if ((value.text != null && value.text != "") || popupMode == 'savedSearch') {
            if (value.type == "row") {
                return <>
                    {isMobilePhone ?
                        <div key={value.type + index} style={index == 0 ? style.mobileRowLastSave : style.mobileRowSava}>
                            <div style={style.mobileColHeadingSave}>{value.label}</div>
                            <div style={style.mobileSaveText}>{value.text}</div>
                        </div>
                        :
                        <div key={value.type + index} style={index == 0 ? style.tableRowSave : style.tableRowSave}>
                            <div style={style.tableColHeadingSave}>{value.label}</div>
                            <div style={style.mobileSaveText}>{value.text}</div>
                        </div>
                    }
                </>
            } else if (value.type == "info") {
                return <>
                    {isMobilePhone ?
                        <div key={value.type + index} style={index == 0 ? style.mobileRowLast : style.mobileRow}>
                            <div style={style.mobileColHeading}>{value.label}</div>
                            <div style={style.tableColBody2}>{value.text}</div>
                        </div>
                        :
                        <div key={value.type + index} style={index == 0 ? style.mobileRowLast : style.blockStyle}>
                            <div style={style.tableColHeadingInfo}>{value.label}</div>
                            <div style={style.tableColBodyHotel}>{value.text}</div>
                        </div>
                    }
                </>
            } else if (value.type == "cancelDescriptions") {
                return <>
                    {isMobilePhone ?
                        <div key={value.type + index} style={index == 0 ? style.mobileRowLast : style.mobileRow}>
                            <div style={style.mobileColHeading}>{value.label}</div>
                            <div style={style.tableColBodyBold}>{messageConst.CANCEL_DESCRIPTION_MESSAGE}</div>
                            <div style={style.tableColCancelDescriptionsMobile}>{value.text}</div>
                        </div>
                        :
                        <div key={value.type + index} style={index == 0 ? style.mobileRowLast : style.blockStyle}>
                            <div style={style.tableColHeadingInfo}>{value.label}</div>
                            <div style={style.tableColBodyBold}>{messageConst.CANCEL_DESCRIPTION_MESSAGE}</div>
                            <div style={style.tableColCancelDescriptions}>{value.text}</div>
                        </div>
                    }
                </>
            } else if (value.type == "title") {
                return <>
                    {isMobilePhone ?
                        <div key={value.type + index} style={index == 0 ? style.mobileRowLast : style.mobileRow}>
                            <div style={style.mobileColHeadingTitle}>{value.label}</div>
                            <div style={style.tableColBodyHotel}>{value.text}</div>
                        </div>
                        :
                        <div key={value.type + index} style={index == 0 ? style.mobileRowLast : style.blockStyle}>
                            <div style={style.tableColHeadingTitle}>{value.label}</div>
                            <div style={style.tableColBodyHotel}>{value.text}</div>
                        </div>
                    }
                </>
            }
        } else if (value.type == "title") {
            return <>
                {isMobilePhone ?
                    <div key={value.type + index} style={index == 0 ? style.mobileRowLast : style.mobileTitle}>
                        <div style={style.mobileColHeadingTitle}>{value.label}</div>
                    </div>
                    :
                    <div key={value.type + index} style={index == 0 ? style.mobileRowLast : style.tableTitle}>
                        <div style={style.tableColHeadingTitle}>{value.label}</div>
                    </div>
                }
            </>
        } else if (value.type == "location") {
            return <>
                {isMobilePhone ?
                    <div key={value.type + index} style={index == 0 ? style.mobileRowLast : style.mobileRow}>
                        <div style={style.mobileColHeading}>{value.label}</div>
                        <div className="addressArea">
                            <img src={icon_pin} style={style.iconPin} />
                            {value.address}
                        </div>
                        <div className={value.access ? "accessArea" : "hiddenItem"}>
                            <img src={icon_car} style={style.iconCar} />
                            {value.access}
                        </div>
                    </div>
                    :
                    <div key={value.type + index} style={index == 0 ? style.mobileRowLast : style.blockStyle}>
                        <div style={style.tableColHeadingInfo}>{value.label}</div>
                        <div className="addressArea">
                            <img src={icon_pin} style={style.iconPin} />
                            {value.address}
                        </div>
                        <div className={value.access ? "accessArea" : "hiddenItem"}>
                            <img src={icon_car} style={style.iconCar} />
                            {value.access}
                        </div>
                    </div>
                }
            </>
        }
    }) : null;

    return (
        <div className={state.reservationPopup ? "popupIsShow" : "popup"} id="js-popup">
            <div ref={popupRef} className={popupMode == "bookConfirm" ? "hiddenItem" : isMobilePhone ? "popupInner_RTCC_media" : "popupInner_RTCC"}>
                <ModalClose divStyle={"modalClose"} svgStyle={"modalSvg"} onClick={() => onClickClosePopupWindow()} />
                <h4 className="popupInnerText" >{popupTitle}</h4>
                <div style={footerClass == "hotel" ? style.tableRow : style.tableNone} >
                </div>
                {popupMode == "message" || popupMode == "saveFavorite" ?
                    <div style={style.messageSave} id="popupText"></div> : <>
                        {footerClass == "hotel" || footerClass == "recommend" ?
                            <Image image={popupData.propertyImages} style={style.image} />
                            : null}
                        <div style={isMobilePhone ? style.tableMobile : style.table}>
                            {popupBody}
                        </div>
                    </>
                }
                <div style={popupMode == 'savedSearch' ? style.deleteButton : { display: "none" }}>
                    <Button className="conditionDelete" onClick={onClickDelete} buttonClassName="buttonText" buttonText="この条件を削除" />
                </div>
                <div className={footerClass == "decision" ? "buttonArea2" : "hiddenItem"} >
                    <Button className="conditionSearch" onClick={onClickDecide} buttonClassName="buttonText" buttonText="決定" />
                </div>
                <div className={footerClass == "message" ? "buttonArea2" : "hiddenItem"} >
                    <Button className="button" onClick={() => onClickClosePopupWindow()} buttonClassName="buttonText" buttonText="OK" />
                </div>
                <div className={footerClass == "hotel" && popupMode == 'planDetail' ? "buttonArea4" : "hiddenItem"} >
                    <Button className="ReservationButtonModal2" onClick={onClickReserve} buttonText="予約する" />
                </div>
                <div className={footerClass == "recommend" ? "buttonArea2" : "hiddenItem"} >
                    <Button className="ReservationButtonModal" onClick={onClickSelect} buttonText="選択する" />
                </div>
                <div className={footerClass == "saveFavorite" ? "buttonArea2" : "hiddenItem"} style={footerClass == "saveFavorite" ? { display: "flex", alignItems: "center", justifyContent: "center" } : { display: "none" }} >
                    <Button className="reservationConfirmBtn" onClick={onClickYes} buttonText="はい" />
                    <Button className="reservationDeleteBtn" onClick={() => onClickClosePopupWindow()} buttonText="いいえ" />
                </div>
            </div>
            <div className={popupMode == "bookConfirm" ? isMobilePhone ? "popupInner_RTCC_reserveConfirm_media" : "popupInner_RTCC_reserveConfirm" : "hiddenItem"}>
                <ModalClose divStyle={"modalClose"} svgStyle={"modalSvg"} onClick={() => onClickClosePopupWindow()} />
                <h4 className="popupInnerText innerText" >{"予約確認・変更・キャンセル"}</h4>
                {popupMode == "bookConfirm" && dataList ? dataList.map((value, index) => {
                    return <div key={"bookConfirm" + index} style={{ background: "#eeeeee96" }}>
                        <div style={style.tableRow2} >
                        </div>
                        <div style={style.message}> {popupMessage}</div>
                        <div style={isMobilePhone ? style.tableMobile : style.table}>
                            <div key={"hotel" + index} style={isMobilePhone ? style.tableRowSp : style.tableRowInfo}>
                                <div style={isMobilePhone ? style.tableColHeadingMob : style.tableColHeading}>宿泊ホテル</div>
                                <div style={style.inline}>{value.hotelName}</div>
                            </div>
                            <div key={"checkIn" + index} style={isMobilePhone ? style.tableRowSp : style.tableRowInfo}>
                                <div style={isMobilePhone ? style.tableColHeadingMob : style.tableColHeading}>チェックイン</div>
                                <div style={style.inline}>{value.checkInDate}</div>
                            </div>
                            <div key={"checkOut" + index} style={isMobilePhone ? style.tableRowSp : style.tableRowInfo}>
                                <div style={isMobilePhone ? style.tableColHeadingMob : style.tableColHeading}>チェックアウト</div>
                                <div style={style.inline}>{value.checkOutDate}</div>
                            </div>
                            <div key={"roomCount" + index} style={isMobilePhone ? style.tableRowSp : style.tableRowInfo}>
                                <div style={isMobilePhone ? style.tableColHeadingMob : style.tableColHeading}>室数</div>
                                <div style={style.inline}>{value.roomList.length}</div>
                            </div>
                            <div key={"guestNum" + index} style={isMobilePhone ? style.tableRowSp : style.tableRowInfo}>
                                <div style={isMobilePhone ? style.tableColHeadingMob : style.tableColHeading}>1室あたりの人数</div>
                                <div style={style.inline}>{value.roomList[0].ageInfo.length}</div>
                            </div>
                            <div key={"reserveId" + index} style={isMobilePhone ? style.tableRowSp : style.tableRowInfo}>
                                <div style={isMobilePhone ? style.tableColHeadingMob : style.tableColHeading}>予約番号</div>
                                <div style={style.inline}>{value.reserveId}</div>
                            </div>
                            <div className="buttonArea3" style={{ display: "flex", alignItems: "center", justifyContent: "center" }} >
                                <Button className="rtcc_reservationConfirmBtn" buttonClassName="buttonText" onClick={() => onClickConfirm(value)} buttonText="予約内容を確認・変更・キャンセル" />
                            </div>
                        </div>
                    </div>
                }) : <div className="noneReserveWrap"><Label label="現在お預かりしているご予約はありません。" /></div>}
            </div>
            <div className="blackBackground" id="js-black-bg"></div>
        </div >
    );
};
const style = {
    popup: {
        position: "fixed",
        left: "0",
        top: "0",
        width: "100%",
        height: "100%",
        zIndex: "9999",
        opacity: "0",
        visibility: "hidden",
        transition: ".6s",
    },
    popupIsShow: {
        position: "fixed",
        left: "0",
        top: "0",
        width: "100%",
        height: "100%",
        zIndex: "9999",
        opacity: "1",
        visibility: "visible",
        transition: ".6s",
    },
    popupInner: {
        position: "absolute",
        left: "50%",
        top: "50%",
        transform: "translate(-50%, -50%)",
        width: "50%",
        backgroundColor: "#fff",
        zIndex: "2",
    },
    popupInnerClose: {
        position: "absolute",
        left: "50%",
        top: "50%",
        transform: "translate(-50%, -50%)",
        width: "50%",
        backgroundColor: "#fff",
        zIndex: "2",
        height: "30%",
    },
    popupInnerMobile: {
        position: "absolute",
        left: "50%",
        bottom: "0%",
        transform: "translate(-50%, 0%)",
        width: "100%",
        backgroundColor: "#fff",
        zIndex: "2",
    },
    popupInnerText: {
        width: "100%",
        textAlign: "center",
    },
    popupInnerTextSp: {
        width: "100%",
        textAlign: "center",
        borderBottom: "1px solid #eee",
        margin: 0,
        padding: "20px 0px 20px 0px"
    },
    closeBtn: {
        position: "absolute",
        right: "15px",
        top: "0",
        width: "50px",
        height: "50px",
        lineHeight: "50px",
        textAlign: "center",
        cursor: "pointer",
        fontSize: "50px",
    },
    svg: {
        height: "20",
        width: "20",
    },
    message: {
        // margin: "30px auto",
        whiteSpace: "pre-line",
        textAlign: "center"
    },
    messageSave: {
        margin: "15% 0px",
        whiteSpace: "pre-line",
        textAlign: "center"
    },
    table: {
        display: "block",
        width: "70%",
        margin: "20px auto",
        borderCollapse: "collapse",
        marginBottom: "0px",
        background: "white",
        marginBottom: "0px",
    },
    tableMobile: {
        display: "block",
        width: "90%",
        margin: "20px auto",
        borderCollapse: "collapse",
        marginBottom: "0px",
        background: "white",
        marginBottom: "0px",
    },
    tableImageRow: {
        display: "block",
        width: "100%",
        textAlign: "center"
    },
    tableTitle: {
        borderTop: "solid 1px rgb(173, 173, 173)"
    },
    tableRowSp: {
        borderBottom: "solid 1px rgb(173, 173, 173)",
        padding: "10px",
        display: "block",
        margin: "7px 10px",
        fontSize: "15px",
        letterSpacing: "1px",
    },
    tableRowInfo: {
        borderBottom: "solid 1px rgb(173, 173, 173)",
        padding: "10px",
        display: "block",
        fontSize: "15px",
        letterSpacing: "1px",
        margin: "7px 40px",
    },
    tableRowSave: {
        display: "block",
        borderBottom: "1px solid rgb(173, 173, 173)",
        padding: "10px",
        margin: "7px 10px",
        fontSize: "15px",
        letterSpacing: "1px",
        display: "flex",
        alignItems: "center",
    },
    tableRow: {
        display: "table-row",
        borderTop: "solid 1px rgb(173, 173, 173)",
        fontSize: "15px",
        letterSpacing: "1px",
    },
    blockStyle: {
        display: "block",
        borderTop: "solid 1px rgb(173, 173, 173)",
        fontSize: "15px",
        letterSpacing: "1px",
    },
    blockRow: {
        borderBottom: "solid 1px rgb(173, 173, 173)",
        padding: "10px",
        display: "table-row",
        fontSize: "15px",
        letterSpacing: "1px",
        margin: "7px 10px",
    },
    tableNone: {
        display: "block",
        fontSize: "15px",
        letterSpacing: "1px",
    },
    tableRow2: {
        padding: "10px",
        display: "block",
        fontSize: "15px",
        letterSpacing: "1px",
    },
    mobileRow: {
        display: "block",
        borderTop: "solid 1px rgb(173, 173, 173)"
    },
    mobileRowSava: {
        display: "block",
        display: "flex",
        alignItems: "center",
        borderTop: "solid 1px rgb(173, 173, 173)"
    },

    tableRowLast: {
        display: "table-row",
    },
    mobileRowLast: {
        display: "block",
    },
    mobileRowLastSave: {
        display: "flex",
        alignItems: "center",
    },
    deleteButton: {
        textAlign: "right",
        width: "90%",
        margin: "0px 0px 30px 0px"
    },
    tableColHeading: {
        display: "inline-block",
        fontWeight: "bold",
        paddingRight: "40px",
        paddingTop: "10px",
        paddingBottom: "10px",
        fontSize: "small",
        width: "20%"
    },
    tableColHeadingSave: {
        display: "inline-block",
        fontWeight: "bold",
        paddingRight: "40px",
        paddingTop: "20px",
        paddingBottom: "20px",
        fontSize: "small",
        width: "33%"
    },
    tableColHeadingSp: {
        display: "table-cell",
        fontWeight: "bold",
        paddingRight: "40px",
        paddingBottom: "30px",
        fontSize: "small",
        width: "33%"
    },
    tableColHeadingMob: {
        fontWeight: "bold",
        fontSize: "small",
        marginBottom: "5px"
    },
    inline: {
        display: "inline-block",
        fontSize: "small",
    },
    tableColHeadingInfo: {
        fontWeight: "bold",
        paddingRight: "40px",
        paddingTop: "30px",
        fontSize: "small",
        width: "80%"
    },
    tableColHeadingTitle: {
        fontWeight: "bold",
        textAlign: "center",
        fontFamily: "serif",
        paddingTop: "30px",
        paddingBottom: "20px",
        fontSize: "large",
        width: "100%",
    },
    mobileColHeadingTitle: {
        fontWeight: "bold",
        textAlign: "center",
        fontFamily: "serif",
        paddingTop: "30px",
        paddingBottom: "20px",
        fontSize: "middle",
        width: "100%",
    },
    mobileColHeading: {
        fontWeight: "bold",
        paddingRight: "20px",
        paddingTop: "30px",
        paddingBottom: "30px",
        fontSize: "small",
        width: "100%"
    },
    mobileColHeadingSave: {
        fontWeight: "bold",
        paddingRight: "20px",
        paddingTop: "15px",
        paddingBottom: "15px",
        fontSize: "small",
        width: "33%"
    },
    mobileSaveText: {
        width: "67%"
    },
    tableColBody: {
        fontSize: "small",
    },
    tableColBody2: {
        fontSize: "small",
        paddingBottom: "20px",
    },
    tableColBodyBold: {
        fontSize: "small",
        fontWeight: "bold"
    },
    tableColCancelDescriptionsMobile: {
        fontSize: "small",
        paddingBottom: "20px",
        whiteSpace: "pre-line"
    },
    tableColCancelDescriptions: {
        fontSize: "small",
        paddingBottom: "20px",
        whiteSpace: "pre-line",
        overflowWrap: "anywhere"
    },
    tableColBodyHotel: {
        fontSize: "small",
        paddingBottom: "20px",
        whiteSpace: "pre-line",
        overflowWrap: "anywhere"
    },
    tableColHeadingLast: {
        display: "table-cell",
        fontWeight: "bold",
        paddingRight: "40px",
        paddingTop: "30px",
        paddingBottom: "40px",
        fontSize: "small",
    },
    tableColBodyLast: {
        display: "table-cell",
        paddingTop: "40px",
        paddingBottom: "40px",
        fontSize: "small",
    },
    tableColBodyLastSp: {
        // display: "table-cell",
        paddingTop: "40px",
        fontSize: "small",
    },
    imageRow: {
        width: "70%",

    },
    image: {
        display: "block",
        width: "100%",
        marginLeft: "0%",
        marginRight: "0%",
        marginBottom: "10%",
    },
    blackBackground: {
        position: "absolute",
        left: "0",
        top: "0",
        width: "100%",
        height: "100%",
        backgroundColor: "rgba(0, 0, 0, .8)",
        zIndex: "1",
    },
    buttonArea: {
        width: "60%",
        textAlign: "center",
        margin: "auto",
        paddingBottom: "40px",
    },
    closeButtonArea: {
        width: "60%",
        textAlign: "center",
        margin: "auto",
        paddingBottom: "40px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        // height: "50%",
    },
    buttonAreaMobile: {
        width: "90%",
        textAlign: "center",
        margin: "auto",
        paddingBottom: "15px",
    },
    button: {
        width: "100%",
        color: "#fff",
        backgroundColor: "#000",
        border: "solid 1px #000",
        padding: "15px 120px 15px 120px",
        cursor: "pointer",
    },
    buttonSearch: {
        width: "100%",
        color: "#fff",
        backgroundColor: "#000",
        border: "solid 1px #000",
        padding: "12px 120px",
        backgroundPosition: 'left 25% bottom 45%',
        backgroundSize: '60% 60%',
        backgroundRepeat: "no-repeat",
        fontSize: "small",
        cursor: "pointer"
    },
    deleteCriteria: {
        color: "#adadad",
        textAlign: "right",
        textDecoration: "underline",
        fontSize: "small",
        cursor: "pointer",
    },
    iconPin: {
        width: "24px",
        height: "30px",
        paddingRight: "2px"
    },
    iconCar: {
        width: "24px",
        height: "20px",
        paddingRight: "2px"
    }
}

const mapStateToProps = (state) => {
    return {
        login: state.login,
        checkIn: state.checkIn,
        course: state.course,
        keyWord: state.keyWord,
        area: state.area,
        startTime: state.startTime,
        detailCondition: state.detailCondition,
        favoriteCondition: state.favoriteCondition,
        reserveInfo: state.reserveInfo,
        toUserInputInfo: state.toUserInputInfo,
        reserveCancelInfo: state.reserveCancelInfo,
        stayInfo: state.stayInfo,
    };
};

const mapToDispatchToProps = (dispatch) => {
    return {
        setSearchResult: (item) => {
            dispatch({ type: "SEARCH_RESULT", payload: item })
        },
        setFavoriteCondition: (condition) => {
            dispatch({ type: "FAVORITE_CONDITION", payload: { favoriteCondition: condition } });
        },
        setStartTime: (item) => {
            dispatch({ type: "START_TIME", payload: { startTime: item } })
        },
        setKeyWord: (item) => {
            dispatch({ type: "KEYWORD", payload: { keyWord: item } })
        },
        setRoomHome: (item) => {
            dispatch({ type: "ROOM_HOME", payload: { roomHome: item } })
        },
        setRoomOverseas: (item) => {
            dispatch({ type: "ROOM_OVERSEAS", payload: { roomOverseas: item } })
        },
        setHuman: (item) => {
            dispatch({ type: "HUMAN", payload: { human: item } })
        },
        setCourse: (item) => {
            dispatch({ type: "COURSE", payload: { course: item } })
        },
        setDetailCondition: (item) => {
            dispatch({ type: "DETAIL_CONDITION", payload: { detailCondition: item } })
        },
        setReserveInfo: (item) => {
            dispatch({ type: "RESERVE_INFO", payload: { reserveInfo: item } })
        },
        setToUserInputInfo: (item) => {
            dispatch({ type: "TO_USERINPUT_INFO", payload: { toUserInputInfo: item } })
        },
        setReserveCancelInfo: (item) => {
            dispatch({ type: "RESERVE_CANCEL_INFO", payload: { reserveCancelInfo: item } })
        },
    };
}

export default connect(mapStateToProps, mapToDispatchToProps)(ReservationPopupContainer);